// clarknow js file
require('./script')

// clarknow scss file
require('../scss/style.scss')


// WEBPACK FOOTER //
// ./assets/js/App.js